import styled from "styled-components";
import { Box } from "../FiltersCommon";
import React, { useState, useEffect, ReactElement } from "react";
import { Calendar } from "react-date-range";
import { ModalContainer, ModalBackdrop } from "../../common/StyledComponents";
import { format } from "date-fns";

import SpinnerWrapper from "../../common/SpinnerWrapper";

import calendarIcon from "../../../../icons/ButtonDatePicker.png";
import calendarIconHover from "../../../../icons/ButtonDatePickerhover.png";
import calendarIconPressed from "../../../../icons/ButtonDatePickerPressed.png";

import { ReactComponent as IconCalendar } from "../../../../icons/icon-calendar.svg";
import { Calendar_SVG } from "../FilterPanelCommon";

const imgs = [calendarIcon, calendarIconHover, calendarIconPressed];

const TextInput = styled.input.attrs(() => ({
  type: "text",
}))`
  height: 100%;
  width: 100%;
  border: none;
  
  user-select: text;

  :focus {
    outline: none;
  }
`;

const FloatRight = styled.div`
  margin-left: auto;
  flex: 0 1 auto;
`;

const InnerBox = styled.div`
  border: 1px solid #78899a;
  // margin: 1px;
  display: flex;
  height: 100%;
  height: 32px;
  padding: 2px 8px;
`;

interface ITextBoxProps {
  value?      : string;
  isLoading?  : boolean;
  style?      : React.CSSProperties;
  isDisabled? : boolean;
  onChange: (newValue: string) => void;
  onKeyPress?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
}

export const TextBox = (props: ITextBoxProps): ReactElement => {
  return (
    <InnerBox style={props.style}>
      <TextInput 
        value={ props.value } 
        disabled={ props.isDisabled }
        onChange={(event) => props.onChange(event.target.value)} 
        onKeyPress={ props.onKeyPress } 
      />
      {props.isLoading && (
        <FloatRight>
          <SpinnerWrapper height={30} width={30} />
        </FloatRight>
      )}
    </InnerBox>
  );
};

const borderColor = "#78899a";

const DateInput = styled.input`
  flex: 1 1 auto;
  height: 30px;
  border: 1px solid ${borderColor};
  border-right: 0px;
  padding: 2px 8px;
`;


const DateButton_SVG = styled(Calendar_SVG)`
  height: 34px;
  width: 34px;
  flex-basis: 34px;
  border: 1px solid ${borderColor};
  justify-content: center;
`;

interface IDateBoxProps {
  onChange: (date: Date) => void;
  format?: string;
  value?: Date;
}

export const DateBox = (props: IDateBoxProps): ReactElement => {
  const [calendarVisible, setCalendarVisible] = useState(false);
  const toggleCalendar = () => setCalendarVisible(!calendarVisible);

  // Selected date changes
  const [selectedDate, setSelectedDate] = useState(props.value);
  useEffect(() => setSelectedDate(props.value), [props.value]);
  const onChange = (date: Date) => {
    setSelectedDate(date);
    props.onChange(date);
    toggleCalendar();
  };

  useEffect(() => {
    for (const imgURL of imgs) {
      const img = new Image();
      img.src = imgURL;
    }
  });

  return (
    <Box style={{ width: '100%', height: '38px', padding: 0, border: 'none'}}>
      <DateInput readOnly={true} value={selectedDate ? format(selectedDate, props.format || "dd.MM.yyyy") : ""} />
      <DateButton_SVG onClick={toggleCalendar}>
        <IconCalendar />
      </DateButton_SVG>
      {calendarVisible && (
        <div>
          <ModalContainer>
            <Calendar onChange={onChange} date={selectedDate} />
          </ModalContainer>
          <ModalBackdrop onClick={toggleCalendar} />
        </div>
      )}
    </Box>
  );
};
